import {Box, Button, FormControl, Grid, Input, InputLabel, makeStyles, MenuItem, OutlinedInput, Select, TextField, withStyles} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import { useToken } from "../../utilities/hooks";

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);
const useStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '1px grey solid',
        borderBottom: '1px grey solid'
    },
    leftSection: {
        paddingTop: theme.spacing(3),

        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',

    },
    rightSection: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        borderLeft: '1px grey solid',
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.grey[500],
    },
    bottomSection: {
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(1),
    }
}))

function SearchActionsSection(props) {
    const classes = useStyle();
    const {t} = useTranslation('driverEfficiencyMonitor');

    const tokenContents = useToken();
    const userUS = tokenContents.userUS;

    const search_type_list = [
        {
            id: 1,
            text: 'batch_number',
            value: 'sub_references'
        },
        {
            id: 2,
            text: 'driver_id',
            value: 'driver_id'
        }
    ]

    return (
        <Box className={classes.root}>
            <Grid
                container
                alignItems="left"
                justify="left"
            >
                <Grid xs={4}
                      alignItems="left"
                      justify="left"
                      style={{marginLeft: 20}}
                >
                    <div className={classes.bottomSection}>
                        <InputTextField
                            style={{width: '100%'}}
                            variant='outlined'
                            placeholder={t('input_service')}
                            onChange={(event) => {
                                props.handleSelectedInput(event.target.value)
                            }}
                            value={props.selectedInput}
                            label={t('batch_num')}
                            id="searchactionsection_selectedinput_inputtextfield"
                        />
                    </div>
                    <span style={{
                        color: "white",
                        fontSize: 11,
                        marginLeft: 13
                    }}>{t('search_tip')}</span>
                </Grid>
                <Grid xs={2} alignItems="left"
                      justify="left">
                    <div className={classes.bottomSection}>
                        <InputTextField
                            style={{width: '100%'}}
                            variant='outlined'
                            placeholder={t('input_service')}
                            onChange={(event) => {
                                props.handleSelectedDriversInput(event.target.value)
                            }}
                            value={props.selectedDrivers}
                            label={t('driver_id')}
                            id="searchactionsection_selecteddrivers_inputtextfield"
                        />
                    </div>
                </Grid>
                <Grid xs={1} alignItems="center"
                      justify="center" item style={{marginLeft: 10}}>
                    <div className={classes.leftSection}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            size="small"
                            style={{width: '100%'}}
                        >
                            <InputLabel>{t('team')}</InputLabel>
                            <Select
                                value={props.selectedTeam}
                                onChange={(event) => {
                                    props.handleSelectedTeam(event.target.value)
                                }}
                                id="searchactionsection_selectedteam_select"
                            > <MenuItem key={0} value={0}>All Team</MenuItem>
                                {props.teamList?.map((team) => {
                                    return <MenuItem key={team.id} value={team.id}>{userUS ? team.name_alias : team.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
                <Grid xs={1} alignItems="center"
                      justify="center" item>
                    <div className={classes.bottomSection} style={{marginTop: 2}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => props.onSearch()}
                            disabled={props.isDataLoading}
                            id="searchactionsection_search_button"
                        >
                            {t('common:search')}
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );

}

export default SearchActionsSection;